import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";

export default function HomeBanner3(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					padding: "0",
					backgroundImage: `url(${banner5})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				
				<div className="container">
					<div className="row" >

						<div className="col-md-6">
							
							<div
								style={{
									padding: "20px",
									marginTop: "30px",
									marginBottom: "30px",
									background: "rgba(255, 255, 255, 0.7)",
								}}

								className=""
							>
								<h6
									className="main-section-title"
								>
									ABOUT US
								</h6>

								<p
									style={{
										fontSize: "18px"
									}}
								>
									Kobe Konsult is an African-origin consulting firm working across the public and private sectors, NGOs, international organisations, and development partners. We focus on research, monitoring and evaluation, project management, capacity building, policy analysis, and organisational development. 
									<br/><br/>
									Our work covers several African countries, with teams that understand local systems and the contexts shaping them.
								</p>

								<div className="mt-5">
									<button
										className="btn btn-padded btn-secondary"
										style={{
											margin: "10px",

										}}
										onClick={() => {
											appContext.navTo({
												item: 'about_us'
											})
										}}
									>
										Learn More About Us...
									</button>
								</div>
							</div>

						</div>

						
					</div>

				
				</div>
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
